import {AxiosInstance, AxiosResponse} from 'axios';
import React, {PropsWithChildren, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {network} from 'src/constants/config';
import {getUser} from '../actions/user';
import {useHistory} from '../imports/Router';
import {createApi} from '../services/api/ApiFactory';
import {createAxios} from '../services/api/AxiosFactory';
import {showAlert} from '../actions/AlertActions';
import useCheckVpn from '../utils/useCheckVpn';
import AsyncStorage from '@react-native-async-storage/async-storage';
export interface ContextType {
  api?: ReturnType<typeof createApi>;
  axios?: AxiosInstance;
}

const ApiContext = React.createContext<ContextType>({});

export const ApiProvider = (props: PropsWithChildren<any>) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [value, setValue] = useState<ContextType>(useContext(ApiContext));
  const { checkVpn } = useCheckVpn()

  //Create
  useEffect(() => {
    const axios = createAxios();
    axios.defaults.timeout = network.timeout;
    setValue({
      api: createApi(axios),
      axios,
    });
  }, []);

  //Network Error
  useEffect(() => {
    value.axios?.interceptors.response.use( undefined , async error => {
      let message = error?.message;
      let isBackgroundApiCall = error?.config.headers?.['Background-Api-Call'];
      if (message === 'Network Error' && !isBackgroundApiCall) {
        checkVpn().then(()=>{
        }).catch(()=>{
        })
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title : t('network_error'),
            },
          }),
        );
      }
      throw error;
    });
  }, [dispatch, value.axios]);

  //Request Timeout 408
  useEffect(() => {
    value.axios?.interceptors.response.use(undefined, async error => {
      const res: AxiosResponse = error.response;
      const status = res?.status;
      let code = error?.code;
      let isBackgroundApiCall = error?.config.headers?.['Background-Api-Call'];
      if (
        (code === 'ECONNABORTED' && !isBackgroundApiCall) ||
        (status === 408 && !isBackgroundApiCall)
      ) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title : t('timoute'),
            },
          }),
        );
      }

      throw error;
    });
  }, [dispatch, value.axios]);

  //Unauthorized 401 - 419
  useEffect(() => {
    value.axios?.interceptors.response.use(undefined, async error => {
      const status = error.response?.status;
      if (status === 401 || status === 419) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title: t('401'),
            },
          }),
        );
        history.replace('/logout');
      }
      throw error;
    });
  }, [dispatch, value.axios]);

  //Server Error 500 to 511
  useEffect(() => {
    value.axios?.interceptors.response.use(undefined, async error => {
  
      const res: AxiosResponse = error.response;
      const status = res?.status;
      let isBackgroundApiCall = error?.config.headers?.['Background-Api-Call'];
      if (
        status >= 500 &&
        status !== 503 &&
        history?.location?.pathname !== '/updating' &&
        !isBackgroundApiCall
      ) {
        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'redExclamation',
              title : t('default_server_error'),
            },
          }),
        );
      }
      throw error;
    });
  }, [dispatch, value.axios]);

  //Service Unavailable 503
  useEffect(() => {
    value.axios?.interceptors.response.use(undefined, async error => {
      const status = error.response?.status;
      let isBackgroundApiCall = error?.config.headers?.['Background-Api-Call'];
      if (
        status === 503 &&
        history?.location?.pathname !== '/updating' &&
        !isBackgroundApiCall
      ) {
        history.replace({
          pathname: '/updating',
          state: {prevRoute: history?.location?.pathname},
        });
      }
      throw error;
    });
  }, [dispatch, value.axios]);
  

  // // //Vpn
  // useEffect(() => {
  //   value.axios?.interceptors.response.use(async response => {
  //     console.log('response' , { response })
  //     // if (response.config.url==='api/configuration' || response.config.url==='api/uploadImage' ) {
  //     //   if (
  //     //     response?.headers?.['x-country'] &&
  //     //     response?.headers?.['x-country'] !== 'IR'
  //     //   ) {
  //     //       dispatch(
  //     //         showAlert({
  //     //           id: 'AlertBox',
  //     //           modalProps: {
  //     //             icon: 'orangeExclamation',
  //     //             message: t('vpn_alert'),
  //     //           },
  
  //     //         }),
  //     //       );
  //     //   }
  //     // }
  //     return response;
  //   }, undefined);
  // }, [dispatch, value.axios]);

  //Refresh token
  // useEffect(() => {
  //   value.axios?.interceptors.response.use(async response => {
  //     if (!!response?.headers?.['new-access-token']) {
  //       dispatch(getUser({token: response?.headers?.['new-access-token']}));
  //     }
  //     return response;
  //   }, undefined);
  // }, [dispatch, value.axios]);

  return value ? (
    <ApiContext.Provider value={value}>{props.children}</ApiContext.Provider>
  ) : null;
};

export const useApi = () => useContext(ApiContext);
